import { privateAxios } from '@/common/api/axios'
import { MetaResponse } from '@/common/types/metaResponse'
import { EstablishmentCompanyData } from '@/features/company/types/company.type'
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'
import { EstablishmentMapAction } from '../pages/Map/types/action'
import { endpointFiltersForActions } from '../pages/Map/utils/endpointFiltersForActions'

type UseEstablishmentCompaniesProps = {
  filters?: {
    search?: string
    productCategoryId?: string
    stateId?: string
    cityId?: string
    status?: string
    commercialKind?: string
    pageSize?: number
  }
  action?: EstablishmentMapAction
}

export const useEstablishmentCompaniesInfiniteQuery = ({
  filters: { search = '', productCategoryId, stateId, cityId, status, commercialKind, pageSize } = {},
  action,
}: UseEstablishmentCompaniesProps) => {
  const { data, isPending, ...rest } = useInfiniteQuery({
    queryKey: [
      'establishmentCompanies',
      search,
      productCategoryId,
      cityId,
      stateId,
      status,
      commercialKind,
      pageSize,
      action?.name,
      ...(action ? Object.values(action?.properties || {}) : []),
    ],
    queryFn: async ({ pageParam }) => {
      const { data } = await privateAxios.get('/establishment/companies', {
        params: {
          search,
          page: pageParam || 1,
          page_size: pageSize,
          'q[product_category_id_eq]': productCategoryId,
          'q[city_id_eq]': cityId,
          'q[state_id_eq]': stateId,
          'q[status_eq]': status,
          'q[commercial_kind_eq]': commercialKind,
          ...endpointFiltersForActions(action),
        },
      })

      return data
    },
    initialPageParam: 0,
    getNextPageParam: ({ meta }: { data: EstablishmentCompanyData[]; meta: MetaResponse }) => {
      return meta.total_pages > meta.current_page ? meta.current_page + 1 : undefined
    },
    placeholderData: keepPreviousData,
  })

  return { data, isPending, ...rest }
}
